// ✅ DYNAMIC OFFSET (DST destekli)
export function getTimezoneOffset(tz, at = new Date()) {
  const now = at;

  const tzDate = new Date(
    now.toLocaleString("en-US", { timeZone: tz })
  );

  const utcDate = new Date(
    now.toLocaleString("en-US", { timeZone: "UTC" })
  );

  return (tzDate - utcDate) / (1000 * 60 * 60);
}

// ✅ SAFE PAD
function pad(arr) {
  if (!Array.isArray(arr) || arr.length !== 1440) {
    return new Array(1440).fill(0);
  }
  return arr;
}

// ✅ CORE TZ SHIFT (BUG FIXED VERSION)
export function buildShiftedWindow({
  prev = [],
  curr = [],
  next = [],
  sourceOffset = 3,
  targetOffset,
}) {
  const shiftMinutes = Math.round((targetOffset - sourceOffset) * 60);

  // 3 gün concat
  const full = [
    ...pad(prev),
    ...pad(curr),
    ...pad(next),
  ];

  const len = full.length;

  // SHIFT
  const shifted = new Array(len);

  for (let i = 0; i < len; i++) {
    let newIndex = i + shiftMinutes;

    while (newIndex < 0) newIndex += len;
    while (newIndex >= len) newIndex -= len;

    shifted[newIndex] = full[i];
  }

  // 🔥 KRİTİK: center window logic (double shift fix)
  const startIndex = 1440 + shiftMinutes;

  const window = [];

  for (let i = 0; i < 1440; i++) {
    let idx = startIndex + i;

    while (idx < 0) idx += len;
    while (idx >= len) idx -= len;

    window.push(shifted[idx]);
  }

  return window;
}

// The day as seen from a timezone `shiftMinutes` ahead of the source clock:
// window start moves back by the shift, so displayed minute d is source minute d - shift.
export function shiftedDay(prev, curr, next, shiftMinutes) {
  const full = [...pad(prev), ...pad(curr), ...pad(next)];
  const start = 1440 - shiftMinutes;
  return full.slice(start, start + 1440);
}
